import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import Layout from './components/Layout/Layout';
import LoginForm from './components/Auth/LoginForm';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Properties from './pages/Properties';
import PropertyRequests from './pages/PropertyRequests';
import Bookings from './pages/Bookings';
import PaymentVerifications from './pages/PaymentVerifications';
import Reports from './pages/Reports';
import Messages from './pages/Messages';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Verifications from './pages/Verifications';
import CompanyVerifications from './pages/CompanyVerifications';
import Disputes from './pages/Disputes';
import Refunds from './pages/Refunds';
import Payouts from './pages/Payouts';
import Coupons from './pages/Coupons';
import SupportMessages from './pages/SupportMessages';
import AccountDeletions from './pages/AccountDeletions';
import './index.css';

// App Routes Component
const AppRoutes = () => {
  const { currentUser, loading } = useAuth();
  const { colors } = useTheme();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: colors.background }}
      >
        <div className="text-center">
          <div
            className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto"
            style={{ borderColor: colors.primary }}
          ></div>
          <p className="mt-4" style={{ color: colors.textSecondary }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <LoginForm />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/property-requests" element={<PropertyRequests />} />
        <Route path="/verifications" element={<Verifications />} />
        <Route path="/company-verifications" element={<CompanyVerifications />} />
        <Route path="/users" element={<Users />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/payment-verifications" element={<PaymentVerifications />} />
        <Route path="/disputes" element={<Disputes />} />
        <Route path="/refunds" element={<Refunds />} />
        <Route path="/payouts" element={<Payouts />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/support-messages" element={<SupportMessages />} />
        <Route path="/account-deletions" element={<AccountDeletions />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <AppRoutes />
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#131C31',
                  color: '#F1F5F9',
                  borderRadius: '14px',
                  border: '1px solid rgba(148, 163, 184, 0.12)',
                  fontSize: '13px',
                  fontWeight: '500',
                  padding: '14px 18px',
                  boxShadow: '0 12px 40px -8px rgba(0, 0, 0, 0.4)',
                },
                success: {
                  iconTheme: {
                    primary: '#22C55E',
                    secondary: '#fff',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#EF4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
